/*
 * @Descripttion:
 * @version:
 * @Author: gonghong
 * @Date: 2024-2-19
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import { staticRoutes } from './route'
import { isAuthValid } from '@/utils/auth'
import Storage from '@/utils/storage'

// 添加静态路由
const router = createRouter({
    history: createWebHashHistory(),
    routes: [...staticRoutes],
})

router.beforeEach(async(to, from, next) => {
    const { Authorization } = to.query
    if (Authorization) {
        Storage.setLocal('access_token', Authorization)
        Storage.setLocal('Authorization', `Bearer ${Authorization}`)
    }
    const Loading = window.$loading || null
    Loading && Loading.start()

    // 路由进入之前
    const isAuth = isAuthValid()
    // 已登录
    if (isAuth) {
        // 路由进入登录页面
        if (to.name === 'login') {
            next('/home')
            return
        }
        next()
    }
    else {
        // 1、如果进入的路由是不需要权限验证则执行
        if (to.meta.ignoreAuth) {
            next()
            return
        }
        if (to.name === 'login') {
            next()
        }
        else {
            next('/login')
        }
    }
})
// 删除/重置路由
export function resetRoute(){
    useRoutesList().routesList.forEach(route => {
        const { name } = route
        router.hasRoute(name) && router.removeRoute(name)
    })
}
export default router
